import SessionEventProto from "../session-event-proto"

export default class EventCustomViewsResetByCompany extends SessionEventProto {

    constructor(sessionEvent:any) {
        super(sessionEvent)
    }

    process() {
        // ignore if from different company (!)
        if (this.isDifferentCompany()) return false

        // reset menu
        gd.session.customViews.resetFromData(this.data)
    }
}